import type { ReactNode } from 'react';

interface BrandCardProps {
  title: ReactNode;
  titleAs?: 'h1' | 'h2';
  children: ReactNode;
}

/** The Part I form card: oxblood title strip over a card-coloured body. */
export function BrandCard({ title, titleAs = 'h1', children }: BrandCardProps) {
  const TitleTag = titleAs;
  return (
    <section className="fc-card">
      <TitleTag className="fc-card-title">{title}</TitleTag>
      <div className="fc-card-body">{children}</div>
    </section>
  );
}
